import { useState } from "react";
import { useQuery } from "@tanstack/react-query";

import { type ExerciseStats } from "@fitness-app/data-models/entities/ExerciseStats";

import { traineeKeys } from "~/modules/Trainee/TraineeProfile/scope";
import { supabase } from "~/store/initializeStore";

export const useExerciseStats = (traineeId: string) => {
  const [selectedExercise, setExercise] = useState<string | null>(null);

  const { data, isLoading } = useQuery([...traineeKeys.all(traineeId), "workoutsStats", "exercise", selectedExercise], {
    keepPreviousData: true,
    queryFn: async () => {
      if (!selectedExercise) {
        return null;
      }
      const { error, data } = await supabase
        .from("workout_exercise_stats")
        .select("*")
        .eq("traineeId", traineeId)
        .eq("exerciseId", selectedExercise)
        .order("eventDate")
        .returns<ExerciseStats[]>();

      if (error) {
        throw new Error(error.message);
      }

      return data;
    },
  });

  return {
    selectedExercise,
    setExercise,
    fetchingExerciseStats: isLoading,
    exerciseStats: data || [],
  };
};
